globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function FacebookIcon() {
  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M18 8.97761C18 4.01941 13.9706 0 9.00001 0C4.02943 0 0 4.01941 0 8.97761C0 13.4586 3.29117 17.1727 7.59375 17.8462V11.5727H5.3086V8.97761H7.59375V6.99973C7.59375 4.74971 8.93738 3.50688 10.9932 3.50688C11.9779 3.50688 13.0078 3.68222 13.0078 3.68222V5.89156H11.8729C10.7549 5.89156 10.4063 6.58359 10.4063 7.29356V8.97761H12.9024L12.5033 11.5727H10.4062V17.8462C14.7088 17.1727 18 13.4586 18 8.97761Z",
      fill: "#1877F2"
    }), /*#__PURE__*/_jsx("path", {
      d: "M12.5711 11.6123L12.9697 9.01479H10.4759V7.32919C10.4759 6.61858 10.8242 5.92592 11.9413 5.92592H13.0751V3.71456C13.0751 3.71456 12.0461 3.53906 11.0623 3.53906C9.00834 3.53906 7.66591 4.78303 7.66591 7.03511V9.01479H5.38281V11.6123H7.66591V17.8914C8.1307 17.9642 8.60045 18.0007 9.07091 18.0006C9.54888 18.0006 10.0181 17.9632 10.4759 17.8914V11.6123H12.5711Z",
      fill: "white"
    })]
  });
}